import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CadastroService } from '../../../../../shared/services/cadastro.service';
import { Cadastro } from '../../../../../shared/interfaces/cadastro';
import { FinancRp } from '../../../../../shared/interfaces/financ-rp';
import { PageResult } from '../../../../../shared/interfaces/page-result';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { debounceTime, tap, switchMap, finalize, catchError, filter, takeUntil, delay, map } from 'rxjs/operators';
import { AppLoaderService } from '../../../../../../app/shared/services/app-loader/app-loader.service';
import { LayoutService } from '../../../../../shared/services/layout.service';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter } from 'angular-calendar';
import * as moment from 'moment';
import { Portador } from '../../../../../shared/interfaces/portador';
import { TipoCobranca } from '../../../../../shared/interfaces/tipo-cobranca';
import { PortadorService } from '../../../../../shared/services/portador.service';
import { TipoCobrancaService } from '../../../../../shared/services/tipo-cobranca.service';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';
import { FinancRpLctoBaixaService } from '../../../../../shared/services/financ-rp-lcto-baixa.service';
import { FinancRpBaixasComponent } from '../financ-rp-baixas/financ-rp-baixas.component';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { FinancRpService } from '../../../../../shared/services/financ-rp.service';
import { FinancRpClassesComponent } from '../financ-rp-classes/financ-rp-classes.component';
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};



@Component({
  selector: "app-financ-rp-popup",
  templateUrl: "./financ-rp-popup.component.html",
  styleUrls: ["./financ-rp-popup.component.scss"],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: "pt-BR" },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class FinancRpPopupComponent implements OnInit {
  public parcelaForm: FormGroup;
  public parcelaDiretivasFatForm: FormGroup;
  public layoutConf: any;

  cadastros: Cadastro[];
  cadastro: Cadastro;
  cep: any;
  isLoading = false;
  isLoadingCadastro = false;
  errorMsg: string;
  parcela: FinancRp;

  portadores: Portador[] = [];
  portador: Portador;

  tipoCobrancas: TipoCobranca[] = [];
  tipoCobranca: TipoCobranca;
  searching: boolean;

  maskFone = {
    mask: "(00) {*}0000-0000",
    lazy: true, // make placeholder always visible
    placeholderChar: "_", // defaults to '_'
  };

  maskCep = {
    mask: "00000-000",
    lazy: true, // make placeholder always visible
    placeholderChar: "_", // defaults to '_'
  };

  maskCpf = {
    mask: "000.000.000-00",
    lazy: true, // make placeholder always visible
    placeholderChar: "_", // defaults to '_'
  };

  maskCnpj = {
    mask: "00.000.000/0000-00",
    lazy: true, // make placeholder always visible
    placeholderChar: "_", // defaults to '_'
  };
  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase(),
  };
  maskLower = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toLowerCase(),
  };

  maskEmail = {
    mask: /^\S*@?\S*$/,
    prepare: (email: any) => email.toLowerCase(),
  };

  protected _onDestroy = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FinancRpPopupComponent>,
    private fb: FormBuilder,
    private loader: AppLoaderService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private financRpLctoBaixaService: FinancRpLctoBaixaService,
    private financRpService: FinancRpService,
    private cadastroService: CadastroService,
    private portadorService: PortadorService,
    private tipoCobrancaService: TipoCobrancaService,
    private layout: LayoutService,
    private confirmService: AppConfirmService
  ) {}

  ngOnInit() {
    console.log(`LancamentoItemDetailsComponent ngOnInit`);
    this.layoutConf = this.layout.layoutConf;
    this.parcela = this.data.payload;
    console.log(`Parcela: ${this.parcela.vendedorId}`);
    console.log(
      `Parcela: Emissao_> ${this.parcela.emissao} - ${
        this.parcela.emissao.toString().split("T")[0]
      }`
    );
    console.log(
      `Parcela: Saldo_> ${
        this.parcela.valorSaldo
      } - ${this.parcela.valorSaldo.toFixed(
        2
      )} - ${this.parcela.valorSaldo.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
      })}`
    );

    this.tipoCobrancaService
      .getTipoCobrancaPage(1, 100)
      .subscribe((tipoCobrancas) => {
        this.tipoCobrancas = tipoCobrancas.content;
        if (
          this.parcela.tipoCobranca !== undefined &&
          this.parcela.tipoCobranca !== null
        ) {
          this.tipoCobrancas.push(this.parcela.tipoCobranca);
        }
      });

    this.portadorService.getPortadorPage(1, 100).subscribe((portadores) => {
      this.portadores = portadores.content;
      if (
        this.parcela.portadorId !== undefined &&
        this.parcela.portadorId !== null
      ) {
        this.portadores.push(this.parcela.portadorId);
      }
    });

    this.buildItemForm(this.parcela);

    /**
     * Search Portador
     */
    this.parcelaForm
      .get("searchPortador")
      ?.valueChanges.pipe(
        filter((search) => !!search),
        tap(() => (this.searching = true)),
        takeUntil(this._onDestroy),
        debounceTime(200),
        map((search) => {
          if (!this.portadores) {
            return [];
          }
          return this.portadorService
            .getPortadorPageSearch(1, 10, search)
            .subscribe((portadores) => {
              this.portadores = portadores.content;
            });
        }),
        delay(500),
        takeUntil(this._onDestroy)
      )
      .subscribe(
        (result) => {
          this.searching = false;
          if (
            this.parcela.portadorId !== undefined &&
            this.parcela.portadorId !== null
          ) {
            if (
              this.portadores
                .map((n) => n.id)
                .includes(this.parcela.portadorId.id)
            ) {
              const portador =
                this.portadores.find(
                  (n) => n.id === this.parcela.portadorId.id
                ) ?? this.parcela.portadorId;
              if (portador !== null && portador !== undefined) {
                this.parcelaForm.controls["portadorId"].setValue(portador);
              }
            } else {
              this.portadores.push(this.parcela.portadorId);
            }
          }
        },
        (error) => {
          this.searching = false;
          this.confirmService.confirm({
            message: `A T E N Ç Ã O !  ERRO PESQUISANDO PORTADOR ... ${error}`,
            error: true,
          });
        }
      );
  }

  buildItemForm(parcela: FinancRp) {
    this.parcelaForm = this.fb.group(
      {
        id: [parcela.id],
        uuid: [parcela.uuid],
        natureza: [parcela.natureza],
        parcela: [parcela.parcela],
        cadastro: [parcela.cadastro],
        fatura: [parcela.fatura],
        docto: [parcela.docto],
        perMulta: [parcela.perMulta],
        carencia: [parcela?.carencia ?? 0],
        emissao: [
          parcela.emissao.toString().split("T")[0],
          [Validators.required],
        ],
        vcto: [parcela?.vcto?.toString().split("T")[0], [Validators.required]],
        prorrogacao: [
          parcela?.prorrogacao?.toString().split("T")[0],
          [Validators.required],
        ],
        prorrogacaoObs: [parcela?.prorrogacaoObs ?? ""],
        dataref: [parcela?.dataref?.toString().split("T")[0]],
        descAte: [parcela.descAte],
        descValor: [parcela.descValor ?? 0],
        desconto: [parcela.desconto],
        moedaId: [parcela.moedaId],
        nossonumero: [parcela.nossonumero],
        numeroboleto: [parcela.numeroboleto],
        perAcrescimo: [parcela.perAcrescimo],
        perJurosmora: [parcela.perJurosmora],
        vendedorId: [parcela.vendedorId],
        vendedorUUID: [parcela.vendedorUUID],
        portadorId: [parcela.portadorId, [Validators.required]],
        statusReg: [parcela.statusReg, [Validators.required]],
        tipoCobranca: [parcela.tipoCobranca, [Validators.required]],
        valorAcrescimo: [parcela.valorAcrescimo, [Validators.required]],
        valorDesconto: [parcela.valorDesconto, [Validators.required]],
        valorJurosmora: [parcela.valorJurosmora, [Validators.required]],
        valorSaldo: [parcela?.valorSaldo ?? 0, [Validators.required]],
        valorTotal: [parcela.valorTotal, [Validators.required]],
        // dias: [parcela.dias, [Validators.required]],
        // vctoLocalDate: [parcela.vctoLocalDate, [Validators.required]],
        // emissaoLocalDate: [parcela.emissaoLocalDate, [Validators.required]],
        // fatCondPgP: [parcela.fatCondPgP],
        searchPortador: [""],
        searchTipoCobranca: [""],
      },
      {
        validators: [this.saldoIgualNominalValidator()],
      }
    );
  }

  //-----------------------------------------------------------------------------//

  onFocusCadastro(event: FocusEvent) {
    this.parcelaForm
      .get("cadastro")
      ?.valueChanges.pipe(
        debounceTime(500),
        tap(() => (this.isLoadingCadastro = true)),
        switchMap((value) =>
          (typeof value === "string"
            ? value !== undefined && value !== ""
              ? this.cadastroService.getCadastroPageSearch(1, 10, value)
              : this.cadastroService.getCadastroPage(1, 10)
            : new Observable<PageResult<Cadastro>>()
          ).pipe(finalize(() => (this.isLoadingCadastro = false)))
        )
      )
      .subscribe((cadastros) => (this.cadastros = cadastros.content));
  }

  onSelectionChangeCadastro(event: any): void {
    if (event.option.value !== undefined) {
      this.cadastro = event.option.value;
    }
  }

  displayFnCadastro(cadastro: Cadastro) {
    if (cadastro) {
      return `${cadastro.codigo} - ${cadastro.nomeFantasia?.trim() ?? ""}`;
    }
  }

  addCadastro() {
    const dialogRef: MatDialogRef<any> = this.dialog.open(
      FinancRpPopupComponent,
      {
        width: "1024px",
        disableClose: true,
        data: { title: "Novo Grupo", payload: {} },
      }
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      this.loader.open("Salvando Cadastro ...");
      this.cadastroService.saveOrUpdate(res).subscribe(
        (data) => {
          this.loader.close();
          this.snack.open("Cadastro Salvo com sucesso!", "OK", {
            duration: 5500,
          });
          this.cadastro = data;
          this.parcelaForm.patchValue({ cadCadastro: data });
        },
        (err: HttpErrorResponse) => {
          this.loader.close();
          this.snack.open("Erro ao salvar o cadastro!", "ERRO", {
            duration: 5500,
          });
        }
      );
    });
  }

  //-----------------------------------------------------------------------------//

  submit() {
    //setar o valor campos que não estão no formulário

    

    this.parcelaForm.patchValue({ id: this.parcela.id });
    this.parcelaForm.patchValue({ uuid: this.parcela.uuid });
    this.parcelaForm.patchValue({ natureza: this.parcela.natureza });
    this.parcelaForm.patchValue({ parcela: this.parcela.parcela });
    this.parcelaForm.patchValue({ fatura: this.parcela.fatura });
    this.parcelaForm.patchValue({ docto: this.parcela.docto });
    this.parcelaForm.patchValue({ perMulta: this.parcela.perMulta });
    this.parcelaForm.patchValue({ carencia: this.parcela.carencia });
    this.parcelaForm.patchValue({ cadastro: this.parcela.cadastro });
    this.parcelaForm.patchValue({ descAte: this.parcela.descAte });
    this.parcelaForm.patchValue({ descValor: this.parcela.descValor });
    this.parcelaForm.patchValue({ desconto: this.parcela.desconto });
    this.parcelaForm.patchValue({ moedaId: this.parcela.moedaId });
    this.parcelaForm.patchValue({ nossonumero: this.parcela.nossonumero });
    this.parcelaForm.patchValue({ perAcrescimo: this.parcela.perAcrescimo });
    this.parcelaForm.patchValue({ perJurosmora: this.parcela.perJurosmora });
    this.parcelaForm.patchValue({ vendedorId: this.parcela.vendedorId });
    this.parcelaForm.patchValue({ vendedorUUID: this.parcela.vendedorUUID });



    //verificar data de prorrogação e prorrogaçãoObs foram alterados

    // if (
    //   (this.parcelaForm.get("prorrogacao")?.value !==
    //     this.parcela.prorrogacao ||
    //     this.parcelaForm.get("prorrogacaoObs")?.value !==
    //       this.parcela.prorrogacaoObs) &&
    //   this.parcelaForm.get("prorrogacao")?.value >
    //     this.parcelaForm.get("emissao")?.value
    // ) {
    //   //confirmar salvar alterações de prorrogação e prorrogaçãoObs
    //   this.confirmService
    //     .confirm({
    //       message: `A T E N Ç Ã O !  Confirma Prorrogação dessa Parcela?`,
    //       error: false,
    //     })
    //     .subscribe((res) => {
    //       if (res) {
    //         console.log(`Prorrogação confirmada`);
    //         this.loader.open();
    //         this.financRpService.saveOrUpdate(res).subscribe(
    //           savedData => {
    //             this.loader.close();
    //             this,this.confirmService.confirm({ message: `Prorrogação salva com sucesso!`, error: false, icon: 'check_circle' });
    //           },
    //           err => {
    //             this.loader.close();
    //             this.confirmService.confirm({ message: `A T E N Ç Ã O ! NÃO FOI POSSÍVEL SALVAR PARCELA: ${JSON.stringify(err)}`, error: true, icon: 'error' });
    //           }
    //         );
    //       } else {
    //         console.log(`Prorrogação cancelada`);
    //       }
    //     });
    // } else {
       
    // }

    this.loader.open("Salvando Fatura/Título ...");
    this.financRpService.saveOrUpdate(this.parcelaForm.value).subscribe(
      (savedData) => {
        this.loader.close();
        // Retorna a parcela efetivamente salva para o chamador aplicar
        // o recálculo das parcelas subsequentes.
        this.dialogRef.close(savedData);
      },
      (err) => {
        this.loader.close();
        this.confirmService.confirm({
          message: `A T E N Ç Ã O ! NÃO FOI POSSÍVEL SALVAR PARCELA: ${JSON.stringify(
            err
          )}`,
          error: true,
          icon: "error",
        });
      }
    );
  }

  close() {
    // Fechamento sem confirmação de salvamento não deve disparar recálculo.
    this.dialogRef.close(null);
  }

  onSelectionChangePortador(event: any): void {
    if (event.value !== undefined) {
      this.portador = event.value;
    }
  }
  onSelectionChangeTipoCobranca(event: any): void {
    if (event.value !== undefined) {
      this.tipoCobranca = event.value;
    }
  }

  consultaBaixas(parcela: FinancRp) {
    this.financRpLctoBaixaService
      .getBaixas(parcela.id.valueOf())
      .subscribe((items) => {
        let dialogRef: MatDialogRef<any> = this.dialog.open(
          FinancRpBaixasComponent,
          {
            width: "1256px",
            disableClose: true,
            data: { title: "Lista de Baixas", payload: items },
          }
        );
      });
  }

  editClasses(parcela: FinancRp) {
    console.log(`editClasses parcela: ${parcela.fatura}`);
    let dialogRef: MatDialogRef<any> = this.dialog.open(FinancRpClassesComponent, {
      width: this.layoutConf?.isMobile ? "100vw" : "1256px",
      maxWidth: this.layoutConf?.isMobile ? "100vw" : "95vw",
      height: this.layoutConf?.isMobile ? "100dvh" : "90vh",
      maxHeight: "100dvh",
      panelClass: this.layoutConf?.isMobile ? "custom-dialog-class" : undefined,
      disableClose: true,
      data: { title: "Classificação/Centro de Custo", payload: parcela },
    });
  }


  onProrrogacaoChange(event: MatDatepickerInputEvent<Date>) {
    const dataProrrogacao = event.value;
    const valorAcrescimo = this.parcelaForm.get('valorAcrescimo')?.value || 0;
    const valorJurosmora = this.parcelaForm.get('valorJurosmora')?.value || 0;

    if (dataProrrogacao && (valorAcrescimo > 0 || valorJurosmora > 0)) {
      this.confirmService.confirm({
        message: '** ATENÇÃO ! *** AO PRORROGAR ESSE TÍTULO SERÁ ZERADO (MULTA/ACRÉSCIMO E JUROS MORA). CONFIRMA PRORROGAÇÃO ?',
        error: false,
        icon: 'warning',
      }).subscribe((res) => {
        if (res) {
          this.parcelaForm.patchValue({
            valorAcrescimo: 0,
            valorJurosmora: 0
          });

          // Recalcula o saldo
          const valorTotal = this.parcelaForm.get('valorTotal')?.value || 0;
          const valorDesconto = this.parcelaForm.get('valorDesconto')?.value || 0;
          const novoSaldo = valorTotal - valorDesconto;
           this.parcelaForm.patchValue({
            valorAcrescimo: 0,
            valorJurosmora: 0,
            valorDesconto: 0,
            valorSaldo: novoSaldo
            });
        }
      });
    }
  }

  saldoIgualNominalValidator() {
    return (form: FormGroup) => {
      const saldo = form.get("valorSaldo")?.value;
      const nominal = form.get("valorTotal")?.value;
      return saldo === nominal ? null : { saldoDiferente: true };
    };
  }
}
